module.exports = __webpack_public_path__ + "static/img/JACK-ISON.de247d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-ISON.jpg
// module id = 2URV
// module chunks = 0